<template>
  <teleport to="body">
    <transition
      enter-active-class="transition-opacity duration-200"
      leave-active-class="transition-opacity duration-150"
      enter-from-class="opacity-0"
      leave-to-class="opacity-0"
    >
      <div
        v-if="show"
        @click.self="$emit('close')"
        class="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-[9999] p-4"
      >
        <div class="card p-6 max-w-md w-full animate-slide-up text-left">
          <div class="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-4">
            <svg class="w-6 h-6 text-primary-600" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </div>
          <h3 class="text-lg font-bold text-slate-900 mb-2">{{ requiresLogin ? 'Login required' : 'Upgrade required' }}</h3>
          <p class="text-sm text-slate-600 mb-6">{{ message }}</p>
          <div class="flex items-center gap-3 justify-end">
            <button @click="$emit('close')" class="btn-ghost">{{ requiresLogin ? 'Cancel' : 'Close' }}</button>
            <button v-if="requiresLogin" @click="goToLogin" class="btn-primary flex items-center gap-2">
              <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                <polyline points="10 17 15 12 10 7" />
                <line x1="15" y1="12" x2="3" y2="12" />
              </svg>
              Login
            </button>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: "LoginPromptModal",
  props: {
    show: { type: Boolean, default: false },
    message: {
      type: String,
      default: "Please login to use this feature.",
    },
    // Set to false when the modal is really an "upgrade your plan" prompt
    // (module locked, not a login gate) — hides the Login CTA accordingly.
    requiresLogin: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["close"],
  methods: {
    goToLogin() {
      this.$emit("close");
      this.$router.push({ name: "LoginPage" });
    },
  },
};
</script>
